<template>
    <div class="divDG">

        <DxDataGrid id="dgrid" class="dx-card wide-card" width="100%" :data-source="dataSource" :key-expr="keyExpr"
            :hover-state-enabled="hoverStateEnabled" :selection="selection" :show-borders="showBorders"
            :columns-auto-width="columnsAutoWidth" :column-min-width="columnMinWidth"
            :allow-column-resizing="allowColumnResizing" :column-resizing-mode="columnResizingMode"
            :allow-column-reordering="allowColumnReordering" :no-data-text="noDataText" @row-click="onRowClick"
            @initialized="onInitialized" @content-ready="onContentReady" @exporting="onExporting"
            @selection-changed="onSelectionChanged" :style="{ 'max-height': gridHeight }">

            <DxExport :enabled="true" />

            <DxStateStoring 
                :enabled="true" 
                type="custom" 
                :custom-load="onLoadState"
                :custom-save="onSaveState" 
            />
            <!-- <DxStateStoring :enabled="true" type="localStorage" storage-key="testv2" /> -->
            <!-- <DxStateStoring :enabled="stateStoringEnabled" :type="stateStoringType" :custom-save="onSaveState" /> -->

            <DxToolbar v-if="showToolbar">
                <DxItem v-if="showAddButton" location="before" template="addRecordTemplate" />
                <DxItem v-if="showStatusFilters" location="before" template="filterStatusCriticalTemplate" />
                <DxItem v-if="showStatusFilters" location="before" template="filterStatusMarginalTemplate" />
                <DxItem v-if="showStatusFilters" location="before" template="filterStatusGoodTemplate" />
                <DxItem v-if="showStatusFilters" location="before" template="filterStatusAllTemplate" />
                <DxItem v-if="showRowCount" location="after" template="rowCountTemplate" />
                <DxItem v-if="showClearFilters" location="after" template="removeFilterRecordTemplate" />
                <DxItem v-if="showRefresh" location="after" template="refreshRecordTemplate" />
                <DxItem v-if="showExport" location="after" name="exportButton" />
                <DxItem v-if="showColumnChooser" location="after" name="columnChooserButton" />
            </DxToolbar>

            <template v-if="showAddButton" #addRecordTemplate>
                <!-- <DxButton text="Add Site" width="150" style="background-color: rgb(255, 115, 0)" hint="Add New Site" -->
                <DxButton icon="add" style="background-color: rgb(255, 115, 0)" hint="Add New Site"
                    @click="onAddRecord"/>
            </template>
            <template v-if="showStatusFilters" #filterStatusCriticalTemplate>
                <DxButton :text="statusIcons.critical" :hint="statusHints.critical"
                    @click="onFilterToggle(statusIcons.critical)" />
            </template>
            <template v-if="showStatusFilters" #filterStatusMarginalTemplate>
                <DxButton :text="statusIcons.marginal" :hint="statusHints.marginal"
                    @click="onFilterToggle(statusIcons.marginal)" />
            </template>
            <template v-if="showStatusFilters" #filterStatusGoodTemplate>
                <DxButton :text="statusIcons.good" :hint="statusHints.good" @click="onFilterToggle(statusIcons.good)" />
            </template>
            <template v-if="showStatusFilters" #filterStatusAllTemplate>
                <DxButton text="All" :hint="statusHints.all" @click="onFilterToggle('')" />
            </template>
            <template v-if="showRefresh" #refreshRecordTemplate>
                <DxButton icon="refresh" :hint="refreshHint" @click="onRefreshData" />
            </template>
            <template v-if="showClearFilters" #removeFilterRecordTemplate>
                <DxButton icon="filter" :hint="clearFiltersHint" @click="onRemoveFilter" />
            </template>
            <template v-if="showRowCount" #rowCountTemplate>
                <div class="mininote">Rows: {{ rowCount }}</div>
            </template>

            <DxLoadPanel :enabled="loadPanelEnabled" />
            <DxColumnChooser v-if="columnChooserEnabled" :enabled="true" :mode="columnChooserMode"
                :sort-order="columnChooserSortOrder">
                <DxPosition my="top right" at="bottom right" of="#dgrid .dx-datagrid-column-chooser-button"
                    offset="0 0" />
            </DxColumnChooser>
            <DxFilterRow v-if="filterRowVisible" :visible="true" />
            <DxHeaderFilter v-if="headerFilterVisible" :visible="true" />
            <DxScrolling :mode="scrollingMode" />
            <DxColumnFixing :enabled="columnFixingEnabled" />
            <DxPager v-if="pagerEnabled" :show-info="pagerShowInfo" :show-page-size-selector="pagerShowPageSizeSelector"
                :allowed-page-sizes="pagerAllowedPageSizes" :show-navigation-buttons="pagerShowNavigationButtons" />
            <DxSorting :mode="sortingMode" />

            <!--
            <DxColumn v-if="showStatusFilters" :data-field="statusFieldName" :show-in-column-chooser="false" caption=""
                width="55px" alignment="left" :allow-resizing="false" :allow-filtering="true"
                :allow-reordering="false" />

            <DxColumn v-for="(config, columnName) in defaultColumnConfig" :key="columnName" :data-field="columnName"
                :caption="capitalize(config.caption || columnName)" v-bind="config" />
            -->
        </DxDataGrid>
    </div>
</template>

<script>
import {
  DxDataGrid,
  DxHeaderFilter,
  DxFilterRow,
  DxScrolling,
  DxColumnChooser,
  DxToolbar,
  DxItem,
  DxPager,
  DxColumnFixing,
  DxStateStoring,
  DxSorting,
  DxPosition,
  DxExport,
} from "devextreme-vue/data-grid";
import { DxButton } from 'devextreme-vue/button';
import { DxLoadPanel } from 'devextreme-vue/load-panel';

export default {
    name: 'TankStatusGrid',
    components: {
        DxButton,
        // DxColumn,
        DxColumnChooser,
        DxColumnFixing,
        DxDataGrid,
        DxFilterRow,
        DxHeaderFilter,
        DxItem,
        DxLoadPanel,
        DxPager,
        DxScrolling,
        DxStateStoring,
        DxToolbar,
        DxSorting,
        DxPosition,
        DxExport
    },
    props: {
        // Data props
        dataSource: {
            type: Array,
            default: () => []
        },
        properties: {
            type: Array,
            default: () => []
        },
        keyExpr: {
            type: String,
            default: 'containerId'
        },
        exportName: {
            type: String,
            default: 'TankStatus'
        },

        // Grid behavior props
        hoverStateEnabled: {
            type: Boolean,
            default: true
        },
        selection: {
            type: Object,
            default: () => ({ mode: 'single' })
        },
        showBorders: {
            type: Boolean,
            default: true
        },
        columnsAutoWidth: {
            type: Boolean,
            default: false
        },
        columnMinWidth: {
            type: Number,
            default: 50
        },
        allowColumnResizing: {
            type: Boolean,
            default: true
        },
        columnResizingMode: {
            type: String,
            default: 'widget'
        },
        allowColumnReordering: {
            type: Boolean,
            default: true
        },
        noDataText: {
            type: String,
            default: 'Loading ...'
        },

        // State storing props
        stateStoringEnabled: {
            type: Boolean,
            default: true
        },
        stateStoringType: {
            type: String,
            default: 'custom'
        },
        stateStorageKey: {
            type: String,
            default: 'tank-status-grid'
        },
        defaultStateConfig: {
            type: Object,
            default: null
        },

        // Toolbar props
        showToolbar: {
            type: Boolean,
            default: true
        },
        showAddButton: {
            type: Boolean,
            default: false
        },
        showStatusFilters: {
            type: Boolean,
            default: true
        },
        showRowCount: {
            type: Boolean,
            default: true
        },
        showClearFilters: {
            type: Boolean,
            default: true
        },
        showRefresh: {
            type: Boolean,
            default: true
        },
        showExport: {
            type: Boolean,
            default: true
        },
        showColumnChooser: {
            type: Boolean,
            default: true
        },

        // Status filter props
        statusIcons: {
            type: Object,
            default: () => ({
                critical: '❌',
                marginal: '⚠️',
                good: '✔️'
            })
        },
        statusHints: {
            type: Object,
            default: () => ({
                critical: 'Filter Critical Values',
                marginal: 'Filter Marginal Values',
                good: 'Filter Good Values',
                all: 'All Statuses'
            })
        },
        statusFieldName: {
            type: String,
            default: 'containerStatus'
        },

        // Other toolbar props
        refreshHint: {
            type: String,
            default: 'Refresh Data'
        },
        clearFiltersHint: {
            type: String,
            default: 'Clear Filters & Sorting'
        },

        // Grid features props
        loadPanelEnabled: {
            type: Boolean,
            default: true
        },
        columnChooserEnabled: {
            type: Boolean,
            default: true
        },
        columnChooserMode: {
            type: String,
            default: 'select'
        },
        columnChooserSortOrder: {
            type: String,
            default: 'asc'
        },
        filterRowVisible: {
            type: Boolean,
            default: true
        },
        headerFilterVisible: {
            type: Boolean,
            default: true
        },
        scrollingMode: {
            type: String,
            default: 'standard'
        },
        columnFixingEnabled: {
            type: Boolean,
            default: false
        },

        // Pager props
        pagerEnabled: {
            type: Boolean,
            default: true
        },
        pagerShowInfo: {
            type: Boolean,
            default: true
        },
        pagerShowPageSizeSelector: {
            type: Boolean,
            default: true
        },
        pagerAllowedPageSizes: {
            type: Array,
            default: () => [20, 50, 100]
        },
        pagerShowNavigationButtons: {
            type: Boolean,
            default: true
        },
        sortingMode: {
            type: String,
            default: 'multiple'
        },

        // Dimension props
        heightOffset: {
            type: Number,
            default: 210
        },

        defaultColumnConfig: {
            type: Object,
            default: null
        },
        useDefaultColumnConfigOnly: {
            type: Boolean,
            default: true
        }
    },

    emits: [
        'row-click',
        'select-container',
        'add-record',
        'refresh-data',
        'filter-toggle',
        'grid-initialized',
        'content-ready',
        'selection-changed'
    ],

    data() {
        return {
            dataGridInstance: null,
            gridHeight: '40vh',
            rowCount: 0,
            preventStateOverride: false,
            canApplySavedState: false
        };
    },

    computed: {
        // remainingProperties() {
        //     if (!this.defaultColumnConfig || !this.properties) return this.properties || [];
        //     const configuredColumns = Object.keys(this.defaultColumnConfig);
        //     return this.properties.filter(prop => !configuredColumns.includes(prop));
        // }
    },

    watch: {
        // dataSource: {
        //     handler(newValue, oldValue) {
        //         if (!oldValue || newValue === oldValue || !newValue || newValue.length === 0) {
        //             return;
        //         }

        //         if (JSON.stringify(newValue) !== JSON.stringify(oldValue) && this.dataGridInstance) {
        //             this.dataGridInstance.refresh();
        //         }
        //     },
        //     deep: true
        // },
        // canApplySavedState(newVal, oldValue) {
        //     if (newVal !== oldValue && this.dataGridInstance) {
        //         this.preventStateOverride = true;
        //         setTimeout(() => this.applySavedStateToGrid(), 100);
        //     }
        // },
        // properties: {
        //     handler(newValue, oldValue) {
        //         if (JSON.stringify(newValue) !== JSON.stringify(oldValue) && this.dataGridInstance) {
        //             this.preventStateOverride = true;
        //             setTimeout(() => this.applySavedStateToGrid(), 100);
        //         }
        //     },
        //     deep: true
        // }
    },

    mounted() {
        window.addEventListener('resize', this.setDimensions);
        this.setDimensions();
    },

    unmounted() {
        window.removeEventListener('resize', this.setDimensions);
    },

    methods: {
        onLoadState() {
            var state = JSON.parse(localStorage.getItem(this.stateStorageKey))
            if (state != null && state != undefined){
                console.log("onLoadState:state found", state)
                if (state.columns[0].visible == true)
                    state.columns[0].visible = false
                if (state.columns[1].width != 55)
                    state.columns[1].width = 55
            }
            else{
                // default config
                state = JSON.parse('{"allowedPageSizes":[20,50,100],"filterPanel":{"filterEnabled":true},"filterValue":null,"searchText":"","pageIndex":0,"pageSize":20,"columns":[{"visibleIndex":0,"dataField":"containerId","name":"containerId","dataType":"number","visible":false},{"visibleIndex":1,"dataField":"containerStatus","name":"containerStatus","dataType":"string","width":55,"visible":true},{"visibleIndex":2,"dataField":"operator","name":"operator","dataType":"string","width":157.296875,"visible":true},{"visibleIndex":3,"dataField":"area","name":"area","dataType":"string","width":157.296875,"visible":true},{"visibleIndex":4,"dataField":"devices","name":"devices","dataType":"string","width":157.296875,"visible":true},{"visibleIndex":5,"dataField":"surface","name":"surface","dataType":"string","width":157.296875,"visible":true},{"visibleIndex":21,"dataField":"dte","name":"dte","dataType":"string","width":122,"visible":true},{"visibleIndex":9,"dataField":"volume (l)","name":"volume (l)","dataType":"string","width":126,"visible":true},{"visibleIndex":10,"dataField":"volume (%)","name":"volume (%)","dataType":"string","visible":false},{"visibleIndex":11,"dataField":"volume (cm)","name":"volume (cm)","dataType":"string","visible":false},{"visibleIndex":13,"dataField":"injection avg","name":"injection avg","dataType":"string","width":141,"visible":true},{"visibleIndex":14,"dataField":"injection target","name":"injection target","dataType":"string","visible":false},{"visibleIndex":15,"dataField":"capacity","name":"capacity","dataType":"string","visible":false},{"visibleIndex":8,"dataField":"product","name":"product","dataType":"string","width":157.296875,"visible":true},{"visibleIndex":7,"dataField":"downhole lsd","name":"downhole lsd","dataType":"string","visible":false},{"visibleIndex":22,"dataField":"last device communication","name":"last device communication","dataType":"string","width":157.328125,"visible":true},{"visibleIndex":16,"dataField":"temperature","name":"temperature","dataType":"string","visible":false},{"visibleIndex":17,"dataField":"satellite connection","name":"satellite connection","dataType":"string","visible":false},{"visibleIndex":18,"dataField":"last24","name":"last24","dataType":"string","visible":false},{"visibleIndex":19,"dataField":"last48","name":"last48","dataType":"string","visible":false},{"visibleIndex":20,"dataField":"last72","name":"last72","dataType":"string","visible":false},{"visibleIndex":6,"dataField":"alias","name":"alias","dataType":"string","visible":false},{"visibleIndex":12,"dataField":"ullage","name":"ullage","dataType":"number","width":97,"visible":true}],"selectedRowKeys":[]}')
                console.log("onLoadState:state not found; applying default", state)
            }
            return state;
        },
        onSaveState(e) {
            localStorage.setItem(this.stateStorageKey, JSON.stringify(e));
        },
        onExporting(e) {
            const currentDate = new Date();
            const yyyy = currentDate.getFullYear();
            const mm = String(currentDate.getMonth() + 1).padStart(2, "0");
            const dd = String(currentDate.getDate()).padStart(2, "0");

            e.fileName = `${this.exportName}_${yyyy}-${mm}-${dd}`;
        },
        setDimensions() {
            const h = document.documentElement.clientHeight;
            this.gridHeight = (h - this.heightOffset) + 'px';
        },
        onContentReady(e) {
            // console.log("onContentReady", e)
            this.rowCount = this.dataGridInstance.totalCount();
            
            this.dataGridInstance.columnOption('containerId', 'showInColumnChooser', false);
        
            this.dataGridInstance.columnOption('containerStatus', {
                showInColumnChooser: false,
                caption: "",
                allowResizing: false,
                allowReordering: false
            });

            // this.canApplySavedState = true;
            this.$emit('content-ready', e);
        },

        onInitialized(e) {
            this.dataGridInstance = e.component;
            this.$emit('grid-initialized', e);
        },

        // applySavedStateToGrid() {
        //     this.preventStateOverride = true;
        //     const savedState = JSON.parse(localStorage.getItem(this.stateStorageKey));
        //     if (savedState && savedState.columns) {
        //         savedState.columns.forEach(savedColumn => {
        //             if (savedColumn.dataField === this.statusFieldName) {
        //                 return;
        //             }
        //             const columnIndex = this.dataGridInstance.columnOption(savedColumn.dataField);

        //             if (columnIndex !== undefined) {
        //                 this.dataGridInstance.deleteColumn(savedColumn.dataField);
        //                 this.dataGridInstance.addColumn(savedColumn);
        //             }
        //         });
        //     }
        //     const propertiesVisibleByDefault = !this.useDefaultColumnConfigOnly && (!this.defaultColumnConfig || !savedState?.columns);

        //     this.remainingProperties.forEach(prop => {
        //         const columnIndex = this.dataGridInstance.columnOption(prop);
        //         const stateColumn = savedState?.columns?.find(col => col.dataField === prop);

        //         if (columnIndex === undefined) {
        //             if (stateColumn) {
        //                 this.dataGridInstance.addColumn(stateColumn);
        //             }
        //             else {
        //                 this.dataGridInstance.addColumn({ dataField: prop, caption: this.capitalize(prop), visible: propertiesVisibleByDefault, showInColumnChooser: true });
        //             }
        //         }
        //     });

        //     // if (savedState && !isNaN(savedState.pageIndex)) {
        //     //     this.dataGridInstance.pageIndex(savedState.pageIndex);
        //     // }

        //     // if (savedState && !isNaN(savedState.pageSize)) {
        //     //     this.dataGridInstance.pageSize(savedState.pageSize);
        //     // }
            
        //     this.preventStateOverride = false;
        //     this.dataGridInstance.refresh();
        // },

        onRemoveFilter() {
            if (this.dataGridInstance) {
                this.dataGridInstance.clearFilter();
                this.dataGridInstance.clearSorting();
            }
        },

        onRefreshData() {
            this.$emit('refresh-data');
        },

        onAddRecord(){
            this.$emit('add-record');
        },

        onFilterToggle(filterArg) {
            if (this.dataGridInstance && this.showStatusFilters) {
                this.dataGridInstance.columnOption(this.statusFieldName, 'filterValue', filterArg);
            }
            this.$emit('filter-toggle', filterArg);
        },

        onRowClick(e) {
            this.$emit('row-click', e);
        },

        onSelectionChanged(e) {
            this.$emit('selection-changed', e);
        },
        // onSaveState(state) {
        //     if (!this.preventStateOverride) {
        //         localStorage.setItem(this.stateStorageKey, JSON.stringify(state));
        //     }
        // },

        clearFilter() {
            this.onRemoveFilter();
        },

        capitalize(str) {
            if (!str || typeof str !== 'string') {
                return str;
            }
            const withSpaces = str.replace(/([a-z])([A-Z])/g, '$1 $2');
            return withSpaces
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        },
    }
};
</script>

<style scoped>
.mininote {
    text-align: left;
    font-size: 11px;
    font-weight: 300;
    color: rgb(255, 125, 0);
}

.pheader {
    font-size: 12px;
    font-weight: 300;
    color: rgb(255, 255, 255, .4);
    margin-bottom: 16px;
    z-index: 20;
}

.pval {
    font-size: 16px;
    font-weight: 300;
    margin-left: 10px;
    margin-bottom: 10px;
    z-index: 20;
}

.divDG {
    border-style: none;
    border-width: 1px;
    margin: 20px;
    border-color: rgb(100, 100, 100);
    border-radius: 6px;
}
</style>
